export type FilterDataType = 'text' | 'number' | 'boolean' | 'enum' | 'date';

export type FilterOperator =
  | 'equals'
  | 'neq'
  | 'startswith'
  | 'contains'
  | 'notcontains'
  | 'gt'
  | 'lt'
  | 'between'

export interface FilterCondition {
  operator: FilterOperator;
  value1?: string | number | null;
  value2?: string | number | null;
}

export interface ColumnFilter {
  values?: Array<string | number | boolean | null>;
  selOptions?: Array<string | number | boolean | null>;
  condition?: FilterCondition | null;
}

export type FilterModel = Record<string, ColumnFilter>;

export type SortDirection = 'asc' | 'desc';

export interface SortDescriptor {
  columnKey: string;
  direction: SortDirection;
}

export type SortModel = SortDescriptor[];

export interface FilterableColumn {
  key: string;
  name: React.ReactNode;
  filterable?: boolean;
  sortable?: boolean;
  filterType?: FilterDataType | string;
  getFilterValue?: (row: any) => any;
  filterField?: string;
  formatFilterValue?: (value: any) => string;
  parseDate?: (value: any) => Date | null;
  showValueList?: boolean;
  columnDetails?: Record<string, any>;
  filterOperators?: FilterOperator[];
  isFilterOptionDisabled?: (optionValue: string, selected: string[]) => boolean;  
  /** Optional: values to tick in the value list for a Custom Filter instead of keeping it as a text condition (null keeps it) */
  getCustomFilterSelection?: (condition: FilterCondition, options: any[]) => string[] | null;
}

export interface FilterChangePayload {
  filterModel: FilterModel;
  sortModel: SortModel;
  changedColumnKey: string | null;
}

export interface FilterIconState {
  filterCount: number;
  sortDirection?: SortDirection;
  sortPriority?: number;
}

export interface SortOption {
  label: string;
  direction: 'asc' | 'desc';
}
export interface SortLabels {
  ascending: SortOption;
  descending: SortOption;
}

export const getSortLabels = (
  columnKey: string,
  columnDetails?: Record<string, any>,
): SortLabels => {
  const rawType = columnDetails?.[columnKey] ?? columnDetails?.[String(columnKey).toLowerCase()];
  const fieldType = String(rawType ?? '').toLowerCase();

  if (fieldType === 'date') {
    return {
      ascending: { label: 'Oldest to Latest', direction: 'asc' },
      descending: { label: 'Latest to Oldest', direction: 'desc' }
    };
  }

  if (fieldType === 'text' || fieldType === 'boolean') {
    return {
      ascending: { label: 'A - Z', direction: 'asc' },
      descending: { label: 'Z - A', direction: 'desc' }
    };
  }

  return {
    ascending: { label: 'Ascending', direction: 'asc' },
    descending: { label: 'Descending', direction: 'desc' }
  };
};